import React, {useContext} from "react";
import ApiContext from "../utils/ApiContext";

export const useApi = () => {
  const api = useContext(ApiContext);
  return api;
};